import { lerp } from 'game/core/lerp';
import { MonoBehavior } from 'game/core/monoBehavior';
import { Time } from 'game/core/pixiRenderer';
import { getScreenSize } from 'game/core/screen';
import { theme } from 'game/theme';
import { Graphics } from 'pixi.js';

export class GamePlaceholderGraphicsAnimation extends MonoBehavior {
    graphic: Graphics;
    gradientPosition = 0;

    constructor() {
        super();
        this.graphic = new Graphics();
    }
    draw(cb: (g: Graphics) => void) {
        cb(this.graphic);
        this.graphic.fill(theme.gamePlaceholder);
    }

    update(): void {
        const { width, height } = getScreenSize();
        this.gradientPosition += 0.026 * Time.deltaTime;
        const pos = this.graphic.position.clone();
        pos.x += this.graphic.width * 0.5;
        pos.y += this.graphic.height * 0.5;
        const xPrc = 1 - ((pos.x / width) % 1);
        const yPrc = 1 - ((pos.y / height) % 1);

        if (this.gradientPosition > 1) {
            this.gradientPosition = this.gradientPosition % 1;
        }
        const gradientPrc = (xPrc + ((yPrc / 2) % 1) + this.gradientPosition) % 1;
        let alphaPrc = 1;
        if (gradientPrc > 0.2 && gradientPrc < 0.5) {
            alphaPrc = lerp(1, 0.6, (gradientPrc - 0.2) / 0.3);
        }
        if (gradientPrc > 0.5 && gradientPrc < 0.8) {
            alphaPrc = lerp(0.6, 1, (gradientPrc - 0.5) / 0.3);
        }
        this.graphic.alpha = alphaPrc;
    }
}
